"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AvatarPlaceholder_1 = require("../../Internal/AvatarPlaceholder");
var UploadAvatar_1 = require("../../Modals/UploadAvatar");
var Thumbnail_1 = require("../Thumbnail");
exports.default = (function (_a) {
    var OnUploadComplete = _a.OnUploadComplete, Src = _a.Src, _b = _a.Size, Size = _b === void 0 ? "Largest" : _b, _c = _a.OccupantSpecies, OccupantSpecies = _c === void 0 ? "Human" : _c, Initials = _a.Initials, AcceptedFileTypes = _a.AcceptedFileTypes, EncoderImageType = _a.EncoderImageType, EncoderOptions = _a.EncoderOptions, MaximumFileSize = _a.MaximumFileSize, rest = __rest(_a, ["OnUploadComplete", "Src", "Size", "OccupantSpecies", "Initials", "AcceptedFileTypes", "EncoderImageType", "EncoderOptions", "MaximumFileSize"]);
    var _d = React.useState({ Image: Src }), state = _d[0], setState = _d[1];
    var thumbnailRef = React.createRef();
    var handleOnComplete = function (image) {
        setState({ IsUploadVisible: false, Image: image });
        OnUploadComplete(image);
        thumbnailRef.current.focus();
    };
    var handleOnCancel = function () {
        setState(__assign(__assign({}, state), { IsUploadVisible: false }));
        thumbnailRef.current.focus();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Thumbnail_1.Thumbnail, __assign({ ref: thumbnailRef }, rest, { Size: Size, Shape: "Circular", Src: state.Image, Placeholder: AvatarPlaceholder_1.AvatarPlaceholder(OccupantSpecies, Initials), ShowUpload: true, OnUploadClick: function () { return setState(__assign(__assign({}, state), { IsUploadVisible: true })); } })),
        state.IsUploadVisible &&
            React.createElement(UploadAvatar_1.UploadAvatar, { OnCancel: handleOnCancel, OnComplete: handleOnComplete, EncoderOptions: EncoderOptions, EncoderImageType: EncoderImageType, MaximumFileSize: MaximumFileSize, AcceptedFileTypes: AcceptedFileTypes })));
});
